import ScriptNode from "./ScriptNode";
import styles from "./index.module.scss";

export default function ScriptsContentPrevious({object, onClickScriptItem}) {
  return (
    <div className={styles.container}>
      <ScriptNode nodeObject={object} depth={0} onClickScriptItem={onClickScriptItem} />
    </div>
  );
}
